export const PageIds = {
  SPACE_INFO: 'spaceInfo',
  STORY_INFO: 'storyInfo',
  SCENE_INFO: 'sceneInfo',
  GAME_PLAY_INFO: 'gamePlayInfo',
  CARD_INFO: 'cardInfo',
  BOT_INFO_1: 'botInfo1',
  BOT_INFO_2: 'botInfo2',
  BOT_INFO_3: 'botInfo3',
  EVENT_CONTENT: 'eventContent',
  EVENT_RELATE_CONTENT: 'eventRelateContent',
  PROPS_INFO_HEAD: 'propsInfoHead',
  PROPS_INFO_HEAD_LEFT: 'propsInfoHeadLeft',
  PROPS_INFO_HEAD_RIGHT: 'propsInfoHeadRight',
  MISSION_EVENT_CONTENT: 'missionEventContent',
  MISSION_EVENT_RELATE_CONTENT: 'missionEventRelateContent',
  MISSION_INFO_HEAD_LEFT: 'missionInfoHeadLeft',
  MISSION_INFO_HEAD_RIGHT: 'missionInfoHeadRight',
  TOOL_INFO: 'toolInfo',
  AIGC_INFO: 'aigcInfo',
  PASS_CONDITION: 'passCondition',
  TRAP_CONDITION: 'trapCondition',
  CHAPTER_INFO: 'chapterInfo',
  AI_TOWN_EDITOR: 'aiTownEditor',
  PUBLISH_INFO: 'publishInfo',
  GAME_PLAY: 'gamePlay',
};

export const TIP_TITLE = 'WujiTitle';
